module.exports = __webpack_public_path__ + "img/s4-2.f9557a33.jpg";